<div class="NotFoundReceiptComponent u-border-radius-md u-color-background-primary u-spacing-2xl-pa">
    <div class="NotFoundReceiptComponent-image-container u-spacing-md-pv">
        <img src="/assets/not_found_img.svg" alt="Not Found Receipt" class="flex-row flex-center u-border-radius-lg u-color-background-secondary u-size-7xl-w u-size-7xl-h" />
    </div>
    <div class="NotFoundReceiptComponent-content">
        <h2 class="NotFoundReceiptComponent-title u-text-title-lg u-spacing-md-mb">No charging sessions found</h2>
        <p class="NotFoundReceiptComponent-description u-text-body-sm u-spacing-lg-mb">
            We couldn’t find any charging receipts matching your search. Note that we only provide receipts for payments made through the payment terminal within the past 12 months.
        </p>
    </div>
    <div class="NotFoundReceiptComponent-action flex-row flex-center">
        <button ce-button ce-button-type-tertiary class="ReceiptComponent-action-search-again" (click)="searchAgain()">Search again</button>
    </div>
</div>
